const AccountType = {
    Agent: 1,
    Supplier: 2,
    getAccountType(label) {
        const selected = String(label);
        if (selected === 'agent') return AccountType.Agent;
        if (selected === 'supplier') return AccountType.Supplier;
        return null;
    }
};

export { AccountType };
export default AccountType;



// WEBPACK FOOTER //
// ./src/enums/accountType.js